<template>
  <div>
    <h2><strong>Generate Polls for LinkedIn</strong> </h2>
    <h5>
      Kindly input a broad topic or subject that you would like the poll to revolve around.
      (Examples are: Technology Trends, Environmental Issues, Health and Wellness)
    </h5>
    <p>
      Write your message in the box below.
    </p>
  </div>
</template>

<script>
export default {
  name: "Display_PaneIntro",
  components: {},
  created(){},
  mounted() {},
  props: {
    output: {
      type: Object,
      required: false,
      default: () => {}
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplayActivity: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplaySettings: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    input(){
      return ""
    }
  },
  methods: {
    handleGenerateClick(){
      this.$emit("generate-click", this.input)
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
